import {
  Users,
  LayoutDashboard,
  ArrowDownToLine,
  ArrowUpFromLine,
  Bot,
  Building,
  CloudUpload,
  DollarSign,
  GitMerge,
  MapPin,
  Navigation,
  Shield,
  ShoppingCart,
  TrendingUp,
  UserCheck,
  Warehouse,
  FileText,
  Binoculars,
  GitBranch,
  Package,
  Scissors,
  Sprout,
  Trees,
  Store,
  CreditCard,
  FileSearch,
  TextSearch,
  PanelBottom,
  Landmark,
  Settings,
  Scale,
} from "lucide-react";
import React from "react";
import { MenuItem } from "../types/menu";
import { Icons } from "../assets/png";

export const SHARED_MENUS: MenuItem[] = [
  {
    key: "users",
    label: "My Users",
    icon: Icons.usersIcon,
    href: "/users",
    displayName: "My Users",
  },
];

export const OWNER_MENUS: MenuItem[] = [
  {
    key: "admins",
    label: "Admins",
    icon: React.createElement(LayoutDashboard, { size: 18 }),
    href: "/sp-admin",
    displayName: "Admin",
  },
];

export const SUPPER_ADMIN_MENUS: MenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: Icons.analyticsIcon,
    href: "/admin",
    displayName: "Dashboard",
  },
  {
    key: "lookup",
    label: "Lookup",
    icon: React.createElement(FileSearch, { size: 18 }),
    children: [
      {
        key: "lookup-main",
        label: "Lookup",
        icon: React.createElement(TextSearch, { size: 18 }),
        href: "/lookup/index",
        displayName: "Lookup",
        isChild: true,
      },
      {
        key: "address",
        label: "Address",
        icon: React.createElement(MapPin, { size: 18 }),
        href: "/lookup/address",
        displayName: "Lookup | Address",
        isChild: true,
      },
      {
        key: "union",
        label: "Union",
        icon: React.createElement(GitMerge, { size: 18 }),
        href: "/lookup/unions",
        displayName: "Lookup | Union",
        isChild: true,
      },
      {
        key: "unit-of-measurement",
        label: "Unit of Measurement",
        icon: React.createElement(Scale, { size: 18 }),
        href: "/lookup/unit-of-measurement",
        displayName: "Lookup | Unit of Measurement",
        isChild: true,
      },
    ],
  },
  {
    key: "agronomy-submenu",
    label: "Agronomy",
    icon: React.createElement(PanelBottom, { size: 18 }),
    children: [
      {
        key: "agronomy",
        label: "Agronomy",
        icon: React.createElement(ShoppingCart, { size: 18 }),
        href: "/agronomy/index",
        displayName: "Agronomy",
        isChild: true,
      },
      {
        key: "farming-stage",
        label: "Farming Stage",
        icon: React.createElement(TrendingUp, { size: 18 }),
        href: "/agronomy/farming-stage",
        displayName: "Agronomy | Farming Stage",
        isChild: true,
      },
      {
        key: "inputs",
        label: "Input Products",
        icon: React.createElement(ArrowDownToLine, { size: 18 }),
        href: "/agronomy/inputs",
        displayName: "Agronomy | Input Products",
        isChild: true,
      },
      {
        key: "products",
        label: "Output Products",
        icon: React.createElement(ArrowUpFromLine, { size: 18 }),
        href: "/agronomy/products",
        displayName: "Agronomy | Output Products",
        isChild: true,
      },
    ],
  },
  {
    key: "organizations",
    label: "Merchants",
    icon: React.createElement(Building, { size: 18 }),
    href: "/organizations",
    displayName: "Merchants",
  },
  {
    key: "wareHouse",
    label: "Warehouse",
    icon: React.createElement(Warehouse, { size: 18 }),
    href: "/warehouse",
    displayName: "Warehouse",
  },
  {
    key: "work-locations",
    label: "Work Locations",
    icon: React.createElement(Navigation, { size: 18 }),
    href: "/workLocations",
    displayName: "Work Locations",
  },
  {
    key: "settings",
    label: "Price Settings",
    icon: React.createElement(DollarSign, { size: 18 }),
    children: [
      {
        key: "input-price",
        label: "Input Price",
        icon: React.createElement(ArrowDownToLine, { size: 18 }),
        href: "/settings/input-price",
        displayName: "Settings | Input Price",
        isChild: true,
      },
      {
        key: "output-price",
        label: "Output Price",
        icon: React.createElement(ArrowUpFromLine, { size: 18 }),
        href: "/settings/output-price",
        displayName: "Setting | Output Price",
        isChild: true,
      },
    ],
  },
  {
    key: "banking",
    label: "Banking",
    icon: React.createElement(Landmark, { size: 18 }),
    children: [
      {
        key: "banks",
        label: "Banks",
        icon: React.createElement(Landmark, { size: 18 }),
        href: "/banking/banks",
        displayName: "Banking | Banks",
        isChild: true,
      },
      {
        key: "loan-configs",
        label: "Loan Configs",
        icon: React.createElement(Settings, { size: 18 }),
        href: "/banking/loan-configs",
        displayName: "Banking | Loan Configs",
        isChild: true,
      },
    ],
  },
  // Include shared menus
  ...SHARED_MENUS,
  {
    key: "all-users",
    label: "All Users",
    icon: React.createElement(UserCheck, { size: 18 }),
    href: "/all-users",
    displayName: "All Users",
  },
  {
    key: "ai",
    label: "AI Test",
    icon: React.createElement(Bot, { size: 18 }),
    children: [
      {
        key: "AIDataIgestion",
        label: "Data ingestion",
        icon: React.createElement(CloudUpload, { size: 18 }),
        href: "/ai/data-ingestion",
        displayName: "AI Test | Data Ingestion",
        isChild: true,
      },
      {
        key: "creditScoring",
        label: "Credit Scoring",
        icon: React.createElement(Shield, { size: 18 }),
        href: "/ai/credit-scoring",
        displayName: "AI Test | Credit Scoring",
        isChild: true,
      },
    ],
  },
];

export const KFT_OPERATION_USER_MENUS: MenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: Icons.analyticsIcon,
    href: "/admin",
    displayName: "Dashboard",
  },
  {
    key: "orders",
    label: "Orders",
    icon: React.createElement(ShoppingCart, { size: 18 }),
    href: "/orders",
    displayName: "Orders",
  },
  {
    key: "farmers",
    label: "Farmers",
    icon: React.createElement(Users, { size: 18 }),
    href: "/customers",
    displayName: "Farmers",
  },
  {
    key: "contract",
    label: "Contracts",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/contracts",
    displayName: "Contracts",
  },
  {
    key: "voucher",
    label: "Vouchers",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/voucher",
    displayName: "Vouchers",
  },
];

export const OFF_TAKER_ADMIN_MENUS: MenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: Icons.analyticsIcon as string,
    href: "/off-taker",
    displayName: "Dashboard",
  },
  {
    key: "orders",
    label: "Orders",
    icon: Icons.shoppingCart,
    href: "/my-orders",
    displayName: "My Orders",
  },
  {
    key: "products",
    label: "Products",
    icon: Icons.cellsIcon,
    href: "/products",
    displayName: "Products",
  },
  {
    key: "scouting",
    label: "Scouting",
    icon: Icons.plantIcon,
    children: [
      {
        key: "pre-planting",
        label: "Pre-Planting",
        icon: Icons.plantIcon,
        href: "/scouting/pre-planting",
        displayName: "Scouting | Pre-Planting",
        isChild: true,
      },
      {
        key: "planting",
        label: "Planting",
        icon: Icons.plantIcon,
        href: "/scouting/planting",
        displayName: "Scouting | Planting",
        isChild: true,
      },
      {
        key: "pre-harvest",
        label: "Pre-Harvest",
        icon: Icons.plantIcon,
        href: "/scouting/pre-harvest",
        displayName: "Scouting | Pre-Harvest",
        isChild: true,
      },
      {
        key: "plant-growth",
        label: "Plant Growth",
        icon: Icons.plantIcon,
        href: "/scouting/plant-growth",
        displayName: "Scouting | Plant-Growth",
        isChild: true,
      },
    ],
  },
  {
    key: "branches",
    label: "Branches",
    icon: Icons.chartIcon,
    href: "/branches",
    displayName: "Branches",
  },
  // Include shared menus
  ...SHARED_MENUS,
  {
    key: "documents",
    label: "Documents",
    icon: Icons.attachmentIcon,
    href: "/documents",
    displayName: "Documents",
  },
];

// ... previous menus (SHARED_MENUS, OWNER_MENUS, SUPPER_ADMIN_MENUS, KFT_OPERATION_USER_MENUS, OFF_TAKER_ADMIN_MENUS) ...

export const OFF_TAKER_OPERATION_MENUS: MenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: Icons.analyticsIcon,
    href: "/off-taker",
    displayName: "Dashboard",
  },
  {
    key: "orders",
    label: "Orders",
    icon: React.createElement(ShoppingCart, { size: 18 }),
    href: "/my-orders",
    displayName: "My Orders",
  },
  {
    key: "products",
    label: "Products",
    icon: React.createElement(Package, { size: 18 }),
    href: "/products",
    displayName: "Products",
  },
  {
    key: "scouting",
    label: "Scouting",
    icon: React.createElement(Binoculars, { size: 18 }),
    children: [
      {
        key: "pre-planting",
        label: "Pre-Planting",
        icon: React.createElement(Sprout, { size: 18 }),
        href: "/scouting/pre-planting",
        displayName: "Scouting | Pre-Planting",
        isChild: true,
      },
      {
        key: "planting",
        label: "Planting",
        icon: React.createElement(Trees, { size: 18 }),
        href: "/scouting/planting",
        displayName: "Scouting | Planting",
        isChild: true,
      },
      {
        key: "pre-harvest",
        label: "Pre-Harvest",
        icon: React.createElement(Scissors, { size: 18 }),
        href: "/scouting/pre-harvest",
        displayName: "Scouting | Pre-Harvest",
        isChild: true,
      },
      {
        key: "plant-growth",
        label: "Plant Growth",
        icon: React.createElement(TrendingUp, { size: 18 }),
        href: "/scouting/plant-growth",
        displayName: "Scouting | Plant-Growth",
        isChild: true,
      },
    ],
  },
];

export const AGRO_DEALER_ADMIN_MENUS: MenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: Icons.analyticsIcon,
    href: "/ad-dashboard",
    displayName: "Dashboard",
  },
  {
    key: "vouchers",
    label: "Vouchers",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/voucher",
    displayName: "Vouchers",
  },
  {
    key: "input-sales",
    label: "Input Sales",
    icon: React.createElement(ShoppingCart, { size: 18 }),
    href: "/input-sales",
    displayName: "Input Sales",
  },
  {
    key: "redemption",
    label: "Payment",
    icon: React.createElement(CreditCard, { size: 18 }),
    href: "/redemptions",
    displayName: "Payment",
  },
  {
    key: "branches",
    label: "Stores",
    icon: React.createElement(Store, { size: 18 }),
    href: "/branches",
    displayName: "Stores",
  },
  // Include shared menus
  ...SHARED_MENUS,
  {
    key: "documents",
    label: "Documents",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/documents",
    displayName: "Documents",
  },
];

export const AGRO_DEALER_OPERATION_MENUS: MenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: Icons.analyticsIcon,
    href: "/ad-dashboard",
    displayName: "Dashboard",
  },
  {
    key: "vouchers",
    label: "Vouchers",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/voucher",
    displayName: "Vouchers",
  },
  {
    key: "input-sales",
    label: "Input Sales",
    icon: React.createElement(ShoppingCart, { size: 18 }),
    href: "/input-sales",
    displayName: "Input Sales",
  },
];

export const AGRO_DEALER_STORE_MENUS: MenuItem[] = [
  {
    key: "redemption",
    label: "Redemption",
    icon: React.createElement(LayoutDashboard, { size: 18 }),
    href: "/redemption",
    displayName: "Redemption",
  },
];

export const BANK_ADMIN_MENUS: MenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: Icons.analyticsIcon,
    href: "/mfi",
    displayName: "Dashboard",
  },
  {
    key: "farmers",
    label: "Farmers",
    icon: React.createElement(Users, { size: 18 }),
    href: "/customers",
    displayName: "Farmers",
  },
  {
    key: "contract",
    label: "Contracts",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/contracts",
    displayName: "Contracts",
  },
  {
    key: "voucher",
    label: "Vouchers",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/voucher",
    displayName: "Vouchers",
  },
  {
    key: "redemption",
    label: "Payment",
    icon: React.createElement(CreditCard, { size: 18 }),
    href: "/redemptions",
    displayName: "Payment",
  },
  {
    key: "branches",
    label: "Branches",
    icon: React.createElement(GitBranch, { size: 18 }),
    href: "/branches",
    displayName: "Branches",
  },
  {
    key: "banking",
    label: "Banking",
    icon: React.createElement(Landmark, { size: 18 }),
    children: [
      {
        key: "loan-configs",
        label: "Loan Configs",
        icon: React.createElement(Settings, { size: 18 }),
        href: "/banking/loan-configs",
        displayName: "Banking | Loan Configs",
        isChild: true,
      },
    ],
  },
  // Include shared menus
  ...SHARED_MENUS,
  {
    key: "documents",
    label: "Documents",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/documents",
    displayName: "Documents",
  },
];

export const BANK_OPERATION_MENUS: MenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: Icons.analyticsIcon,
    href: "/mfi",
    displayName: "Dashboard",
  },
  {
    key: "farmers",
    label: "Farmers",
    icon: React.createElement(Users, { size: 18 }),
    href: "/customers",
    displayName: "Farmers",
  },
  {
    key: "contract",
    label: "Contract",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/contracts",
    displayName: "Contract",
  },
  {
    key: "voucher",
    label: "Vouchers",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/voucher",
    displayName: "Vouchers",
  },
  {
    key: "redemption",
    label: "Redemption",
    icon: React.createElement(CreditCard, { size: 18 }),
    href: "/redemption",
    displayName: "Redemption",
  },
  {
    key: "branches",
    label: "Branches",
    icon: React.createElement(GitBranch, { size: 18 }),
    href: "/branches",
    displayName: "Branches",
  },
  {
    key: "inputSales",
    label: "Input Sales",
    icon: React.createElement(ShoppingCart, { size: 18 }),
    href: "/documents",
    displayName: "Input Sales",
  },
];

export const INSURANCE_ADMIN_MENUS: MenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: Icons.analyticsIcon,
    href: "/insurance",
    displayName: "Dashboard",
  },
  {
    key: "contracts",
    label: "Contracts",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/contracts",
    displayName: "Contacts",
  },
  {
    key: "branches",
    label: "Branches",
    icon: React.createElement(GitBranch, { size: 18 }),
    href: "/branches",
    displayName: "Branches",
  },
  // Include shared menus
  ...SHARED_MENUS,
  {
    key: "documents",
    label: "Documents",
    icon: React.createElement(FileText, { size: 18 }),
    href: "/documents",
    displayName: "Documents",
  },
];
